<template>
    <div class="pt-5">
        <div v-for="{number, description} in itineraryDays" :key="number" class="pb-8">
            <span
                v-for="(day, index) in dayAccommodations(number)"
                :key="`${index}-day-${number}`"
                class="text-medium-emphasis"
            >
                <span v-if="index > 0 && index < dayAccommodations(number)?.length"> / </span>
                {{ day.cityId }}
            </span>
            <v-row dense>
                <v-col cols="12" md="2">
                    <div class="d-flex flex-wrap ga-1">
                        <v-icon start size="large" icon="mdi-weather-sunny" />
                        <span class="text-capitalize"> {{ $t('day') }} {{ number }} </span>
                    </div>
                </v-col>
                <v-col cols="12" md="10">
                    <div v-if="description" class="pb-4" v-html="description" />
                    <div
                        v-for="(day, index) in dayAccommodations(number)"
                        :key="`${index}-accommodation-${number}`"
                        class="pb-2"
                    >
                        <div class="text-uppercase">{{ $t('hotel_name') }}:</div>
                        <div
                            v-for="hotel in day.categoryToHotel"
                            :key="`accommodation-${hotel.id}`"
                            class="text-medium-emphasis"
                        >
                            {{ hotel.categoryInf?.name }}:
                            <span
                                class="text-decoration-underline cursor-pointer"
                                :data-cy="hotel.id"
                                @click="showModal(hotel)"
                            >
                                {{ hotel.hotelInf.name }}
                            </span>
                            <span
                                v-for="(star, starIndex) in Array.from(Array(hotel.hotelInf.category).keys())"
                                :key="`star-${starIndex}`"
                            >
                                *
                            </span>
                            <span class="ml-1"> {{ $t('or_similar') }}</span>
                        </div>
                    </div>
                </v-col>
            </v-row>
        </div>
    </div>
    <HotelInfoModal />
</template>
<script setup lang="ts">
    import HotelInfoModal from '~/components/modals/HotelInfoModal.vue'
    import {SHOW_HOTEL_INFO_MODAL} from '~/utils/event-bus'

    const props = defineProps<{
        itineraryDays: any
        accommodations: any
    }>()

    const selectedHotel = ref()

    const showModal = hotel => {
        selectedHotel.value = hotel
        EventBus.$emit(SHOW_HOTEL_INFO_MODAL, {
            hotelId: selectedHotel.value.hotelInf?.id,
            hotelName: selectedHotel.value.hotelInf?.name,
            hotelStars: selectedHotel.value.hotelInf?.category,
            mainImage: selectedHotel.value.hotelInf?.imageUrl,
            request: {hotelId: selectedHotel.value.hotelInf?.id},
        })
    }

    const dayAccommodations = day => {
        return props.accommodations?.filter(
            ({dayNumberFrom, dayNumberTo}) => dayNumberFrom <= day && day <= dayNumberTo
        )
    }
</script>
